

import state from './moduleMenusState.js'
import mutations from './moduleMenusMutations.js'
import actions from './moduleMenusActions.js'

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
